import produce from "immer";

import { DlpState, PremiumTerms as DlpPremiumTerms } from "../../providers/dlpFlow/DlpFlow.interfaces";
import { DupState, PremiumTerms as DupPremiumTerms } from "../../providers/dupFlow/DupFlow.interfaces";

export interface ApplicationDetailsResponse {
  type: InsuranceType;
  applicationId: string;
  json: string;
}

interface DupApplicationDetails {
  type: "DUP";
  data: DupApplication;
}

interface DlpApplicationDetails {
  type: "DLP";
  data: DlpApplication;
}

type DupApplication = DupState & { premium?: DupPremiumTerms; oneTimePolicyCosts?: string };
type DlpApplication = DlpState & { premium?: DlpPremiumTerms };

type InsuranceType = "DUP" | "DLP";

const getApplicationData = (application: ApplicationDetailsResponse): DupApplicationDetails | DlpApplicationDetails => {
  const applicationData = JSON.parse(application.json) as DupApplication | DlpApplication;
  if (application.type === "DUP") {
    return {
      type: "DUP",
      data: applicationData as DupApplication,
    };
  }
  return {
    type: "DLP",
    data: applicationData as DlpApplication,
  };
};

interface State {
  loading: boolean;
  application: DupApplicationDetails | DlpApplicationDetails | null;
  dictionary: Record<string, string>;
}

export const initialState: State = {
  loading: false,
  application: null,
  dictionary: {},
};

type Action =
  | { type: "FETCH_DATA" }
  | {
      type: "FETCH_SUCCESS";
      payload: { data: { application: ApplicationDetailsResponse; dictionary: Record<string, string> } };
    }
  | { type: "FETCH_ERROR" };

export const applicationDetailsReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "FETCH_DATA":
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case "FETCH_SUCCESS":
      return produce(state, (draft) => {
        const { application, dictionary } = action.payload.data;

        const data = getApplicationData(application);

        draft.loading = false;
        draft.application = data;
        draft.dictionary = dictionary;
      });
    case "FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
      });
  }
};
